/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-empty */
import React, { useEffect, useState } from 'react'
import BackButton from '../../../components/Button/BackButton'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../../redux/actions'
import { Link, useParams, useHistory } from 'react-router-dom'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import dayjs from 'dayjs'
import moment from 'moment'
// components
import {
  Box,
  Button,
  Flex,
  Select,
  Skeleton,
  Stack,
  IconButton,
} from '@chakra-ui/react'
import SpinnerLoading from 'components/Loading/SpinnerLoading'
import ChartRenderingComponent from '../../../components/Graphs/Functions/ChartRendering'
import SearchGraph from './SearchGraph'
import UserRoles from '../../../config/UserRoles'

// ! ตอนนี้กราฟ จะ Rander ได้เฉพาะข้อมูลที่เป็น Number ยังไม่สามารถ Rerender จากข้อมูลที่เป็น Boolean ได้
export default function GraphGroup({ sidebarStatus, setIsShowSidebar }) {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [currentGroup, setcurrentGroup] = useState()
  const [isFetchNewOne, setisFetchNewOne] = useState(true)
  const [isFirstTime, setIsFirstTime] = useState(true)
  const [priority, setPriority] = useState()
  const [priGauge, setPriGauge] = useState()
  const dispatch = useDispatch()
  const params = useParams()
  const currentStation = useSelector((state) => state.station)
  const allLogs = useSelector((state) => state.log)
  //const allPredictionLogs = useSelector((state) => state.logPrediction)
  const [graphMin, setGraphMin] = useState(undefined)
  const [graphMax, setGraphMax] = useState(undefined)
  const [tickAmount, setTickAmount] = useState(8)
  const [valueFormat, setValueFormat] = useState('HH:mm')
  const [graph4, setGraph4] = useState('')
  const [Sg, setSG] = useState([])
  const [graphSelect, setGraphSelect] = useState([])
  const me = useSelector((state) => state.me)
  const history = useHistory()
  const [testArray, setTestArray] = useState(5)
  const [activeTab, setActiveTab] = useState()
  const vasibleTabs = 3
  const [startIndex, setStartIndex] = useState(0)
  const handlePrev = () => {
    setStartIndex(startIndex - 1)
  }
  const handleNext = () => setStartIndex(startIndex + 1)
  const fetchMoreData = () => {
    setTimeout(() => {
      setTestArray(testArray + 5)
    }, 2000)
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(actions.stationGet(params.stationId))
        setisFetchNewOne(false)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }

    fetchData() // เรียกใช้งานฟังก์ชัน async ที่สร้างขึ้น

    return () => {}
  }, [params.stationId, isFetchNewOne])

  useEffect(() => {
    let timeOut
    const fetchLog = async () => {
      try {
        if (params.stationId) {
          console.log('Fetching the log Firsttime or not', isFirstTime)
          if (isFirstTime === true) {
            dispatch(
              actions.logOnDaySpecific(
                params.stationId,
                dayjs().toDate(),
                dayjs().toDate(),
                'log1mm'
              )
            ).then(() => {
              timeOut = setTimeout(() => {
                setIsLoading(true)
              }, 1000)
            })
          } else {
            dispatch(
              actions.logOnDaySpecific(
                params.stationId,
                dayjs().toDate(),
                dayjs().toDate(),
                'log1mm'
              )
            )
          }
        }
      } catch (error) {
        console.error('Error fetching station data:', error)
      }
    }

    fetchLog()
    return () => {
      if (timeOut) {
        clearTimeout(timeOut)
      }
    }
  }, [isFetchNewOne, params.stationId, params.groupId])

  // // ? เราจำเป็นต้อง Fetch ค่าจากทุุกสถานีมาก่อน แล้วค่อยใช้ Use State แบ่งเอา
  // // เพราะเราต้องโชว์ใน Sidebar ทุกอัน
  useEffect(() => {
    const og = []

    if (currentStation) {
      const tempGroup = _.find(
        currentStation?.groups,
        (group) => group?._id === params?.groupId
      )
      setcurrentGroup(tempGroup)
      setActiveTab(tempGroup?.groupName)
      const tempPriority = _.find(
        currentStation?.priority,
        (prior) => prior?.role === me?.role
      )
      setPriority(tempPriority)
      //console.log('temp Pri', tempPriority)
      _.map(priority?.chart, (chartS) => {
        const GG = _.filter(currentStation?.charts, (ch, ind) => {
          if (ch._id === chartS) {
            // return gg
            og.push(ch)
          }
        })
        //console.log('GG', GG)
        return GG
      })
      setPriGauge(og)
      //  console.log('priGauge', og)
    }
    return () => {}
  }, [params, isFetchNewOne, currentGroup])
  // //console.log('GG', priority, priGauge)

  const findGroup = () => {
    let groupList = [] // กลุ่มที่อนุญาติให้เห็น
    if (me?.role === UserRoles.ROLES.USER) {
      groupList = _.filter(
        currentStation?.groups,
        (g) => g.role === UserRoles.ROLES.USER
      )
    } else if (me?.role === UserRoles.ROLES.ADMIN) {
      groupList = _.filter(
        currentStation?.groups,
        (g) =>
          g.role === UserRoles.ROLES.ADMIN || g.role === UserRoles.ROLES.USER
      )
    } else if (me?.role === UserRoles.ROLES.MANAGER) {
      groupList = _.filter(
        currentStation?.groups,
        (g) =>
          g.role === UserRoles.ROLES.USER ||
          g.role === UserRoles.ROLES.ADMIN ||
          g.role === UserRoles.ROLES.MANAGER
      )
    } else if (me?.role === UserRoles.ROLES.SUPER_USER) {
      groupList = currentStation?.groups
    }
    return _.map(
      groupList?.slice(startIndex, startIndex + vasibleTabs),
      (group, index) => {
        return (
          <Link
            to={
              '/dashboards/graphgroup/' + currentStation._id + '/' + group._id
            }
          >
            <Button
              key={index}
              // colorScheme="gray"
              className={`flex-1 text-center text-lg font-medium border-b-4 transition-all duration-300  ${
                activeTab === group.groupName
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500'
              }`}
              onClick={() => setActiveTab(group.groupName)}
            >
              {group.groupName}
            </Button>
          </Link>
        )
      }
    )
  }

  useEffect(() => {
    if (isFetchNewOne === false) {
      setTimeout(() => {
        setisFetchNewOne(true)
      }, 60000)
      //ปรับกราฟใหม่ ทุกๆ 60 วินาที
    }
    return () => {}
  }, [isFetchNewOne])

  const settingsSlide = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    lazyLoad: true,
    slidesToScroll: 1,
    autoplay: false,
    rows: 5,
    cssEase: 'linear',
    appendDots: (dots) => (
      <div
        style={{
          // backgroundColor: '#ddd',
          // borderRadius: '10px',
          padding: '10px',
        }}
      >
        <ul style={{ margin: '20px' }}> {dots} </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={{
          width: '30px',
          color: 'blue',
          border: '1px blue solid',
          padding: '4px 4px 4px 4px',
          borderRadius: '4px',
        }}
      >
        {i + 1}
      </div>
    ),
  }

  useEffect(() => {
    const GroupChart = _.orderBy(priGauge, 'orderLevel', 'asc')
    //console.log('charts', GroupChart, priGauge)
    const Sg = []
    const searchGraph = () =>
      _.map(currentGroup?.chart, (chartS) => {
        const GG = _.filter(GroupChart, (gg, ind) => {
          if (gg._id === chartS) {
            Sg.push(gg)
          }
        })
        return GG
      })

    searchGraph()
    setSG(Sg)
    setGraphSelect(Sg)

    return () => {}
  }, [priGauge, isFetchNewOne, currentGroup])

  const lastHour = () => {
    let timeOut
    dispatch(
      actions.logOnDaySpecific(params.stationId, graphMin, graphMax, 'log1mm')
    ).then(() => {
      timeOut = setTimeout(() => {
        setIsLoading(true)
      }, 2000)
    })

    if (timeOut) {
      clearTimeout(timeOut)
    }
  }

  const lastDay = () => {
    let timeOut
    dispatch(
      actions.logOnDaySpecific(params.stationId, graphMin, graphMax, 'log1h')
    ).then(() => {
      timeOut = setTimeout(() => {
        setIsLoading(true)
      }, 2000)
    })

    if (timeOut) {
      clearTimeout(timeOut)
    }
  }

  const lastWeek = () => {
    let timeOut
    dispatch(
      actions.logOnDaySpecific(params.stationId, graphMin, graphMax, 'log1d')
    ).then(() => {
      timeOut = setTimeout(() => {
        setIsLoading(true)
      }, 2000)
    })

    if (timeOut) {
      clearTimeout(timeOut)
    }
  }

  const lastMonth = () => {
    let timeOut
    dispatch(
      actions.logOnDaySpecific(params.stationId, graphMin, graphMax, 'log1d')
    ).then(() => {
      timeOut = setTimeout(() => {
        setIsLoading(true)
      }, 2000)
    })

    if (timeOut) {
      clearTimeout(timeOut)
    }
  }
  // console.log('currentStation.charts', currentStation, allLogs)
  return isLoading && currentStation ? (
    <div className="relative flex flex-col min-w-0 break-words bg-gray-100 w-full mb-6 shadow-lg rounded">
      <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
        <div className="flex flex-wrap items-center">
          <div className="relative w-full max-w-full flex-grow flex-1">
            <h6 className="uppercase text-gray-500 mb-1 text-xs font-semibold font-sans ">
              {t('dashboard.dashboardMonitor')}
            </h6>
            <h2 className="text-gray-800 text-2xl font-bold font-sans">
              {t('dashboard.graph')} {currentStation.name}
            </h2>
          </div>
        </div>
        <Button>
          <BackButton />
        </Button>
      </div>
      <div className="flex flex-auto justify-center gap-1">
        <IconButton
          icon={<ChevronLeft />}
          isDisabled={startIndex === 0}
          onClick={handlePrev}
        />
        {findGroup()}
        <IconButton
          icon={<ChevronRight />}
          isDisabled={
            startIndex + vasibleTabs <= currentGroup?.length - vasibleTabs
          }
          onClick={handleNext}
        />
      </div>
      <div className="flex justify-between p-4">
        <h2 className="text-gray-800 text-xl px-10 font-bold font-sans">
          กลุ่ม {currentGroup?.groupName}
        </h2>
        <SearchGraph
          data={Sg} //ข้อมูลทั้งหมด
          setData={setGraphSelect} // เซ็ต temp data ให้เหลือเท่าที่กรอง
        />
        <div className="flex justify-items-end">
          <Button
            colorScheme="gray"
            variant="solid"
            size="sm"
            onClick={() => setIsShowSidebar(!sidebarStatus)}
          >
            {t('dashboard.toggleSidebar')}
          </Button>
        </div>
      </div>
      <div>
        <Slider {...settingsSlide}>
          {_.map(graphSelect, (chart, index) => {
            return (
              <div className={'p-4 w-full'}>
                {/* <h2>chart {index}</h2> */}
                <ChartRenderingComponent
                  multichart={false}
                  key={index}
                  chartData={chart}
                  data={allLogs}
                  graphMax={graphMax}
                  graphMin={graphMin}
                  setGraphMax={setGraphMax}
                  setGraphMin={setGraphMin}
                  setTickAmount={setTickAmount}
                  setValueFormat={setValueFormat}
                  tickAmount={tickAmount}
                  valueFormat={valueFormat}
                  stationData={currentStation}
                  enableTimeSelect={true}
                />
                <Stack direction={['column', 'row']} spacing={['2', '4']}>
                  <Button
                    size="sm"
                    onClick={() => {
                      lastHour()
                      setGraphMin(undefined)
                      setGraphMax(undefined)
                      // setGraphMin(moment().subtract('hours').toDate().getTime())
                      // setGraphMax(moment().ad('hours').toDate().getTime())

                      setTickAmount(10)
                      setValueFormat('HH:mm')
                    }}
                  >
                    {t('graph.hourAgo')}
                  </Button>
                  <Button
                    size="sm"
                    onClick={() => {
                      setGraphMin(
                        moment().subtract(1, 'days').toDate().getTime()
                      )
                      setGraphMax(moment().add(2, 'hours').toDate().getTime())
                      setIsLoading(false)
                      lastDay()
                      setTickAmount(12)
                      setValueFormat('HH:mm')
                    }}
                  >
                    {t('graph.dayAgo')}
                  </Button>
                  <Button
                    size="sm"
                    onClick={() => {
                      setGraphMin(
                        moment().subtract(1, 'weeks').toDate().getTime()
                      )
                      setGraphMax(moment().add(1, 'days').toDate().getTime())
                      setIsLoading(false)
                      lastWeek()
                      setTickAmount(7)
                      setValueFormat('DD MMM YYYY')
                    }}
                  >
                    {t('graph.weekAgo')}
                  </Button>
                  <Button
                    size="sm"
                    onClick={() => {
                      setGraphMin(
                        moment().subtract(1, 'months').toDate().getTime()
                      )
                      setGraphMax(moment().add(2, 'days').toDate().getTime())
                      setIsLoading(false)
                      setTickAmount(6)
                      lastMonth()
                      setValueFormat('DD MMM YYYY')
                    }}
                  >
                    {t('graph.monthAgo')}
                  </Button>
                </Stack>
              </div>
            )
          })}
        </Slider>
      </div>
    </div>
  ) : (
    <SpinnerLoading />
  )
}
